export let headerCard = {
	alignment: 'LEFT',
	isLaunchScreenEnabled: false,
};

export const setter = (props) => {
	headerCard = {
		...headerCard,
		...props,
	};
};
